var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"flex items-center justify-center h-full text-2xl w-full"},[_vm._v(" Media kits are currently under construction. Please contact your account manager to submit any changes in the meantime. ")])}
var staticRenderFns = []

export { render, staticRenderFns }